import React, { useEffect, useRef, useState } from "react";
import "./GlobalScope.css";

export default function GlobalScope() {
  const sectionRef = useRef(null);

  const [startCount, setStartCount] = useState(false);
  const [years, setYears] = useState(0);
  const [countries, setCountries] = useState(0);

  const [leader, setLeader] = useState({
    title: "",
    description: "",
    stat1: 0,
    stat1_label: "",
    stat2: 0,
    stat2_label: "",
    image: ""
  });

  /* ===============================
     FETCH LEADER DATA
  ================================ */
  useEffect(() => {
    fetch("https://pharma.accendiatechnologies.com/batterjee/getvideos.php")
      .then(res => res.json())
      .then(data => {
        if (data.status === "success" && data.leader) {
          setLeader({
            title: data.leader.title || "",
            description: data.leader.description || "",
            stat1: parseInt(data.leader.stat1) || 0,
            stat1_label: data.leader.stat1_label || "",
            stat2: parseInt(data.leader.stat2) || 0,
            stat2_label: data.leader.stat2_label || "",
            image: data.leader.image || ""
          });
        }
      })
      .catch(() => {});
  }, []);

  /* ===============================
     OBSERVER
  ================================ */
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCount(true);
          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  /* ===============================
     YEARS COUNTER
  ================================ */
  useEffect(() => {
    if (!startCount) return;
    if (years < leader.stat1) {
      const timer = setTimeout(() => setYears(prev => prev + 1), 120);
      return () => clearTimeout(timer);
    }
  }, [startCount, years, leader.stat1]);

  /* ===============================
     COUNTRIES COUNTER
  ================================ */
  useEffect(() => {
    if (!startCount) return;
    if (countries < leader.stat2) {
      const timer = setTimeout(() => setCountries(prev => prev + 2), 30);
      return () => clearTimeout(timer);
    }
  }, [startCount, countries, leader.stat2]);

  return (
    <section className="global-scope" ref={sectionRef}>
      <div className="scope-container">

        {/* LEFT */}
        <div className="scope-left">
          <h2 dangerouslySetInnerHTML={{ __html: leader.title }} />

          <div
            dangerouslySetInnerHTML={{ __html: leader.description }}
          />

          <div className="scope-highlight">
            <span className="number">{years}+</span>
            <span className="text">{leader.stat1_label}</span>
          </div>
        </div>

        {/* CENTER */}
        <div className="scope-center">
          {leader.image && (
            <img src={leader.image} alt="Global Presence" />
          )}
        </div>

        {/* RIGHT */}
        <div className="scope-right">
          <h3>International Scope</h3>
          <p>Operating in</p>

          <div className="countries">
            <span className="plus">+</span>
            <span className="count">{countries}</span>
            <span className="label">{leader.stat2_label}</span>
          </div>
        </div>

      </div>
    </section>
  );
}
